import Swiper from "swiper/swiper-bundle";

export default{ 
  init() {
    var AmnestyClub = new Swiper('.amnesty-container', {
      slidesPerView: 3,
      slidesPerColumn: 1,
      spaceBetween: 24,
      loop: true,
      navigation: {
        nextEl: '.amnesty.swiper-button-next',
        prevEl: '.amnesty.swiper-button-prev',
        clickable: true,
      },
      breakpoints: {
        1400: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        576: {
          slidesPerView: 1,
        },
        320: {
          slidesPerView: 1,
        },
      },
    });
  },
  finalize() {},
};